export const SET_INSTITUTIONS = 'institution/SET_INSTITUTIONS';
export const SET_CURRENT_INSTITUTION = 'institution/SET_CURRENT_INSTITUTION';
export const SET_ORG_MEMBERS = 'insitution/SET_ORG_MEMBERS';
export const SET_INSTITUTIONS_LOADING = 'institution/SET_INSTITUTIONS_LOADING';
export const ADD_INSTITUTION = 'institution/ADD_INSTITUTION';
